import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-steps", () => {
    it("[Auto Generated without Slots] should render 5 children, 1 active and 2 done elements", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-steps items="5" current="3"></ux-steps>`);
        const el = await page.find("ux-steps");
        const stepsTotal = await el.findAll(`ux-steps-item`);
        const stepsActive = await el.findAll(`ux-steps-item.ux-steps-item--active`);
        const stepsDone = await el.findAll(`ux-steps-item.ux-steps-item--done`);
        expect(stepsActive.length).toBe(1);
        expect(stepsDone.length).toBe(2);
        expect(stepsTotal.length).toBe(5);
    });

    it("[Generated with Slots] should render 3 children, 1 active and 1 done elements", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-steps><ux-steps-item number="1" done>Breakfast</ux-steps-item>
<ux-steps-item number="2" current>Lunch</ux-steps-item><ux-steps-item number="3">Dinner</ux-steps-item></ux-steps>`
        );
        const el = await page.find("ux-steps");
        const stepsTotal = await el.findAll(`ux-steps-item`);
        const stepsActive = await el.findAll(`ux-steps-item.ux-steps-item--active`);
        const stepsDone = await el.findAll(`ux-steps-item.ux-steps-item--done`);
        expect(stepsActive.length).toBe(1);
        expect(stepsDone.length).toBe(1);
        expect(stepsTotal.length).toBe(3);
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-steps items="5" current="3"></ux-steps>`);
    });
});
